import { ISubjectQuotas } from "../reduxSlices/subjectsSlice";
import { IQuota } from "../types";
export const getCourseQuota = (subjectQuotas: ISubjectQuotas, idCupo: number): IQuota => {
  try {
    const keys = Object.keys(subjectQuotas);
    if (!keys.includes(idCupo.toString())) {
      throw new Error(`No quota found`);
    } else {
      const quota = subjectQuotas[idCupo];
      return quota;
    }
  } catch (error) {
    // console.log(`Cannot get course quota idCupo: ${idCupo}`);
    return { quotaId: -1, qty: 0, availability: 0, cursoId: -1, anioLectivo: -1, readyToUse: true, lastUpdateTimestamp: 0 };
  }
};
